import { render, staticRenderFns } from "./BridgeInfo.vue?vue&type=template&id=1b94d1d1&"
import script from "./BridgeInfo.vue?vue&type=script&lang=js&"
export * from "./BridgeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports